import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { TRANSPORT_TYPE } from 'src/app/constants';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { TruckService } from 'src/app/services/truck/truck.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Events } from '@ionic/angular';

const INPUT_FORMAT = 'DD/MM/YYYY';

@Component({
  selector: 'app-truck-data',
  templateUrl: './truck-data.page.html',
  styleUrls: ['./truck-data.page.scss'],
})
export class TruckDataPage implements OnInit {

  numberPlateWrapper: any;
  lastValidation: string = moment().format(INPUT_FORMAT);

  truckDataForm: FormGroup;
  disabledByDefault: boolean = true;
  transportTypes = Object.keys(TRANSPORT_TYPE);

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private truckService: TruckService,
    private events: Events,
  ) {
    this.truckDataForm = this.formBuilder.group({
      name: ['', [Validators.maxLength(150)]],
      titleHolder: ['', [Validators.required, Validators.maxLength(150)]],
      kilometers: ['', [Validators.maxLength(150)]],
      transportType: ['', Validators.required],
      expirationTruck: this.formBuilder.group({
        insurance: [{ value: '', disabled: this.disabledByDefault }],
        fee: ['', Validators.required],
        inspection: ['', Validators.required],
      }),
      specifications: ['', Validators.maxLength(320)],
    });

    if (this.router.getCurrentNavigation().extras.state.numberPlateRes) {
      const temp = this.router.getCurrentNavigation().extras.state.numberPlateRes;
      this.numberPlateWrapper = temp;
    }
   }

  ngOnInit() {
    this.fillFormFields();
  }

  fillFormFields() {
    const date = moment(this.numberPlateWrapper.expiry);
    this.truckDataForm.patchValue({ expirationTruck : { insurance: date.format(INPUT_FORMAT) } });
  }

  emulatePipe(transportTypes: any[]): any[] {
    return transportTypes.filter((key) => key !== TRANSPORT_TYPE.all && key !== TRANSPORT_TYPE.foot_cycle);
  }

  selectedFeeExpirationDate(date: moment.Moment) {
    this.truckDataForm.get('expirationTruck').get('fee').setValue(date.format(INPUT_FORMAT));
  }

  selectedInspectionExpirationDate(date: moment.Moment) {
    this.truckDataForm.get('expirationTruck').get('inspection').setValue(date.format(INPUT_FORMAT));
  }

  async confirmTruckData() {
    await this.alertService.confirm({
      messageKey: 'VEHICLE_ADD_TO_FLEET',
      okHandler: async () => await this.saveTruckData()
    });
  }

  async saveTruckData() {
    try {
      await this.spinnerService.show();

      const token = await this.authService.getToken();
      const truck = this.truckDataForm.getRawValue();

      truck.numberPlate = (this.numberPlateWrapper.numberPlate + '').toUpperCase();

      let insuranceExpDate = truck.expirationTruck.insurance;
      let feeExpDate = truck.expirationTruck.fee;
      let inspecExpDate = truck.expirationTruck.inspection;

      truck.expirationTruck.insurance = insuranceExpDate ? moment(insuranceExpDate, INPUT_FORMAT).toDate() : null;
      truck.expirationTruck.fee = feeExpDate ? moment(feeExpDate, INPUT_FORMAT).toDate() : null;
      truck.expirationTruck.inspection = inspecExpDate ? moment(inspecExpDate, INPUT_FORMAT).toDate() : null;

      await this.truckService.sendTruckData(token, truck);

      await this.alertService.toastSuccess();
      await this.spinnerService.dismiss();

      this.events.publish('callback-truck');
      this.router.navigate(['/profile'], { replaceUrl: true });
    } catch (err) {
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

}
